// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"Select_wrapper__2mTJK","selectWrapper":"Select_selectWrapper__P5M2f","select":"Select_select__2c2LY","icon":"Select_icon__2kt-n","title":"Select_title__3ilo5"};